/*
 * cron-card 定时任务卡
 * Schema: { name, cron_expr, status, delivery?, next_run? }
 */
import React from 'react'
import { tryParseJson, CronCardData, CronStatus } from './types'
import { useInvalidBlockWarning } from './useInvalidBlockWarning'
import './CronCardBlock.scss'

interface CronCardBlockProps {
  code: string
}

const STATUS_CONFIG: Record<CronStatus, { label: string; className: string }> =
  {
    created: { label: '已创建', className: 'aiClerk-block-cron__status--ok' },
    updated: { label: '已更新', className: 'aiClerk-block-cron__status--info' },
    enabled: { label: '已启用', className: 'aiClerk-block-cron__status--ok' },
    disabled: {
      label: '已暂停',
      className: 'aiClerk-block-cron__status--gray'
    },
    deleted: { label: '已删除', className: 'aiClerk-block-cron__status--err' }
  }

export const CronCardBlock: React.FC<CronCardBlockProps> = ({ code }) => {
  const data = tryParseJson<CronCardData>(code)

  // 流式中 JSON 未收齐时 silent 不渲染，避免闪"定时任务数据无效"（对齐 FileListBlock）；
  // 流式结束后仍无效 → useInvalidBlockWarning 会 console.warn 留排查线索
  const valid = !!data && !!data.name && !!data.cron_expr
  useInvalidBlockWarning('cron-card', code, valid)
  if (!data || !data.name || !data.cron_expr) {
    return null
  }

  const cfg = STATUS_CONFIG[data.status] || STATUS_CONFIG.created

  return (
    <div className="aiClerk-block-cron">
      <div className="aiClerk-block-cron__header">
        <div className="aiClerk-block-cron__icon">⏰</div>
        <div className="aiClerk-block-cron__name">{data.name}</div>
        <div className={`aiClerk-block-cron__status ${cfg.className}`}>
          {cfg.label}
        </div>
      </div>
      <div className="aiClerk-block-cron__body">
        <div className="aiClerk-block-cron__row">
          <span className="aiClerk-block-cron__label">调度</span>
          <code className="aiClerk-block-cron__expr">{data.cron_expr}</code>
        </div>
        {data.next_run && (
          <div className="aiClerk-block-cron__row">
            <span className="aiClerk-block-cron__label">下次执行</span>
            <span>{data.next_run}</span>
          </div>
        )}
        {data.delivery && (
          <div className="aiClerk-block-cron__row">
            <span className="aiClerk-block-cron__label">投递</span>
            <span>{data.delivery}</span>
          </div>
        )}
      </div>
    </div>
  )
}
